import React from 'react';
import TeaserGalleryShowcase from '../Views/TeaserGalleryShowcase';

/**
 * TeaserGalleryShowcaseView - Route component for the Teaser Gallery Showcase
 * Simple wrapper that renders the TeaserGalleryShowcase component
 */
const TeaserGalleryShowcaseView = () => {
  return <TeaserGalleryShowcase />;
};

export default TeaserGalleryShowcaseView;
